import { ChartType, ColumnChartName } from '@ddt-web/chart';

export class ChartConfig {
	// type and name refer to bfa-chart properties
	constructor(public type: ChartType, public name: string | ColumnChartName, public customAttributes: any) { }
}
